import * as React from 'react';

export const isActivationKey = (e: React.KeyboardEvent<HTMLElement>): boolean =>
  e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
